export class FrequentFlyerInfo {

  frequent_flyer_number: string;
  airline_code: string;
  name: string;

  public constructor(fields?: any) {

    if (fields) {
      Object.assign(this, fields);
    }
  }
}
